/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { MiniDrawerComponent } from './mini-drawer';
export * from './mini-drawer-constants';
export * from './mini-drawer';
export function defineMiniDrawerComponent() {
    defineCustomElement(MiniDrawerComponent);
}
